import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import axios from "axios";

const AenxosJuridica = ({ id }) => {
  const [gestiones, setGestiones] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      axios
        .get(
          "https://contratosback-dev.azurewebsites.net/api/v1/ObtenerAnexosJuridica/" +
            id
        )
        .then((response) => {
          setGestiones(response.data);
        })
        .catch((error) => {
          console.error("Error al obtener las gestiones:", error);
        });
    }
  };

  return (
    <div className="text-center mt-4">
      <Button color="info" onClick={toggle}>
        Consultar
      </Button>
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Gestiones</ModalHeader>
        <ModalBody>
          <Table striped>
            <thead>
              <tr>
                <th>ID</th>
                <th>ID Solicitud</th>
                <th>Nombre</th>
                <th>Url</th>
              </tr>
            </thead>
            <tbody>
              {gestiones.length > 0 ? (
                gestiones.map((gestion) => (
                  <tr key={gestion.id}>
                    <td>{gestion.id}</td>
                    <td>{gestion.idSolicitud}</td>
                    <td>{gestion.nombre}</td>

                    <td>
                      <a
                        href={gestion.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Descargar
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No hay datos disponibles
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default AenxosJuridica;
